/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */

import { hubResource } from '../services/resources';
import { HubApp } from '../ui/hub';
import { HUB_ROUTE_NAME, HUB_ROUTE_PATH } from './constants';
export var hubRoute = {
  component: HubApp,
  exact: true,
  name: HUB_ROUTE_NAME,
  resources: [hubResource],
  path: HUB_ROUTE_PATH
};